import { Component, ChangeDetectorRef, OnDestroy } from '@angular/core'
import { ActivatedRoute, Router } from '@angular/router'
import { Company } from 'src/app/models/company.model'
import { Plant } from 'src/app/models/plant.model'
import { Unit } from 'src/app/models/unit.model'
import { CompanyService } from 'src/app/services/company/company.service'
import { ErrorHandlerService } from 'src/app/services/errorHandler/error-handler.service'
import { PlantService } from 'src/app/services/plant/plant.service'
import { ToastService } from 'src/app/services/toast/toast.service'
import { UnitService } from 'src/app/services/unit/unit.service'
import { Roles } from "src/app/auth/roles";
import { RefreshStateService } from 'src/app/services/refresh-state/refresh-state.service'

@Component({
	standalone: false,
	selector: 'app-unit',
	templateUrl: './unit.component.html',
	styleUrls: ['./unit.component.css'],
})
export class UnitComponent implements OnDestroy {
	readonly Roles = Roles;
	activeItem = 0
	adminCompany: any = []
	assignedPlants: any = []
	companies: Company[] = []
	currentRole: any = ''
	firstRender: boolean = false
	plants: Plant[] = []
	resetPlant: boolean = false
	selectedUnit = ''
	showCompanies = false
	showDeactivateMenu = false
	showMenu = false
	showPlants = false
	showToast: boolean = false
	toastText: string = ''
	units: Unit[] = []

	//pagination data
	currentPage: number = 1
	data: Plant[] = []
	pageSize: number = 7
	totalPages: number = 1
	loopArray: number[] = []

	deactivateText = {
		title: 'Deactivate Branch',
		message1: '',
		message2: 'This action is irreversible. Do you wish to proceed?',
	}

	emptyStateCompanies = {
		imgPath: '../../assets/unit.svg',
		message1: 'Select an Account Holder to see associated branches listed here',
		message2: '',
	}
	emptyStatePlants = {
		imgPath: '../../assets/unit.svg',
		message1: 'Select a client to see associated branches listed here',
	}
	emptyState = {
		imgPath: '../../assets/unit.svg',
		message1: 'No branches to display',
		message2: 'Created branches will appear here.',
	}

	errorMessage = {
		success: true,
		message: '',
	}

	get values() {
		return {
			data: this.data,
			currentPage: this.currentPage,
			totalPages: this.totalPages,
			loadData: this.loadData,
			loopArray: this.loopArray,
		}
	}

	selectedValues = {
		company: {
			companyId: 0,
			companyName: '',
			isDeleted: false,
		},
		plant: {
			plantId: 0,
			plantName: '',
			isDeleted: false,
		},
	}

	unitDetails: Unit = {
		unitId: 0,
		unitName: '',
		isDeleted: false,
		plant: [],
		companyId: 0,
	}

	// styles
	defaultStyle = {
		flex: 1,
	}

	specialStyle = {
		flex: 0.5,
	}

	constructor(
		private route: ActivatedRoute,
		private plantService: PlantService,
		private companyService: CompanyService,
		private unitService: UnitService,
		private router: Router,
		public toastService: ToastService,
		private errorService: ErrorHandlerService,
		private changeDetector: ChangeDetectorRef,
		private refreshState: RefreshStateService,
	) {}

	activateAddUnitBtn() {
		if (this.currentRole === Roles.superAdmin) {
			if (
				this.selectedValues.company.companyId === 0 ||
				this.selectedValues.plant.plantId === 0
			) {
				return false
			} else if (
				this.selectedValues.company.isDeleted ||
				this.selectedValues.plant.isDeleted
			) {
				return false
			} else {
				return true
			}
		} else if (this.currentRole === Roles.admin) {
			if (
				this.selectedValues.plant.plantId === 0 ||
				this.selectedValues.plant.plantId == null ||
				this.selectedValues.plant.plantId == undefined ||
				this.selectedValues.plant.plantName.length === 0 ||
				this.selectedValues.plant.isDeleted
			) {
				return false
			} else {
				return true
			}
		}
		return true
	}

	handleDeactivate() {
		this.unitService.deactivateUnit(this.selectedUnit).subscribe({
			next: (response) => {
				this.handleSuccessToast('Deactivate_Unit')
				this.setPlant(this.selectedValues.plant)
			},
			error: (error) => {
				this.errorService.handleError(error, 'Error deactivating branch')
			},
		})
	}

	handleSuccessToast(state: any) {
		if (state === 'Edit_Unit') {
			this.toastService.toastText = 'Branch successfully updated!'
		}
		if (state === 'Add_Unit') {
			this.toastService.toastText = 'Branch successfully added!'
		}
		if (state === 'Deactivate_Unit') {
			this.toastService.toastText = 'Branch successfully deactivated!'
		}
		this.toastService.showToast = state || false
		setTimeout(() => {
			this.toastService.showToast = false
		}, 5000)
	}

	goToDynamic() {
		this.router.navigateByUrl('add-branch', {
			state: this.selectedValues.company,
		})
	}

	isSelectionByUser(): boolean {
		return !(this.changeDetector as any).destroyed
	}

	loadData(plantId: number) {
		const unitRequest = {
			plantId: plantId.toString(),
			pageNumber: this.currentPage,
			pageSize: this.pageSize,
		}

		this.unitService.retrieveUnitPlantByPage(unitRequest).subscribe({
			next: (result: any) => {
				this.units = result.item1
				this.data = result.item1
				this.totalPages = result.item2
				this.updateLoopArray()
			},
			error: (err) => this.errorService.handleRetrievalErrors(err),
		})
	}

	onPageChange(pageNumber: any) {
		this.currentPage = pageNumber
		this.persistRefreshState()
		this.loadData(this.selectedValues.plant.plantId)
	}

	showDeactivateModal(name: string, unitId: any) {
		this.selectedUnit = unitId

		this.deactivateText.message1 =
			'You are about to deactivate ' +
			name +
			' in Smart Forms. Doing this will deactivate all objects related to this branch.'
		this.showDeactivateMenu = true
	}

	setPlant(item: any) {
		this.selectedValues.plant = {
			plantId: item.plantId,
			plantName: item.plantName,
			isDeleted: item.isDeleted,
		}

		this.loadData(this.selectedValues.plant.plantId)
		this.persistRefreshState()
	}

	setSelectedCompany(item: any) {
		if (item.companyId === this.selectedValues.company.companyId) return
		const initalState = { plantId: 0, plantName: '', isDeleted: false }
		if (
			this.isSelectionByUser() &&
			(this.selectedValues.plant.plantId > 0 || this.plants.length > 0)
		) {
			this.resetPlant = true
			this.plants = []
			this.selectedValues.plant = { ...initalState }
		}
		this.units = []
		this.retrievePlantsByCompanyId(item.companyId.toString())

		this.selectedValues.company = item
		this.resetPlant = false
		this.persistRefreshState()
	}

	retrievePlantsByCompanyId(id: string) {
		this.plantService.retrieveCompanyPlants(id).subscribe({
			next: (response) => {
				const plantsArrayWithoutCompany = response.map(
					({ plantId, plantName, isDeleted }) => ({
						plantId,
						plantName,
						isDeleted,
					}),
				)

				this.plants = plantsArrayWithoutCompany
			},
			error: (err) => {
				this.errorMessage = this.errorService.handleRetrievalErrors(err)
			},
		})
	}

	setSelectedPlant(plantId: number, plantName: string) {
		this.loadData(plantId)
		this.selectedValues.plant = { plantId, plantName, isDeleted: false }
		this.persistRefreshState()
	}

	toggleMenu(plantId: any) {
		this.activeItem = plantId
		this.showMenu = !this.showMenu
	}

	toggleSelect() {
		this.showCompanies = !this.showCompanies
	}

	toggleSelectCompany() {
		this.showCompanies = !this.showCompanies
	}

	toggleSelectPlant() {
		this.showPlants = !this.showPlants
	}

	transferData() {
		this.firstRender = true
		this.router.navigateByUrl('settings/branch', {
			state: {
				selectedValues: { ...this.selectedValues },
				firstRender: this.firstRender,
			},
		})
	}

	updateLoopArray() {
		this.loopArray = new Array(this.totalPages)
			.fill(0)
			.map((_, index) => index + 1)
	}

	ngOnInit(): void {
		this.handleSuccessToast(history.state.prevPage)
		const saved = this.refreshState.load<{ selectedValues: any; currentPage: number }>('settings:units')
		this.firstRender = history.state.firstRender || Boolean(saved?.selectedValues?.plant?.plantId)
		this.currentRole = localStorage.getItem('role')
		if (!history.state.firstRender && saved) {
			this.selectedValues = saved.selectedValues
			this.currentPage = Math.max(1, saved.currentPage || 1)
		}
		if (this.firstRender) {
			if (history.state.firstRender) this.selectedValues = { ...history.state.selectedValues }
			if (this.selectedValues.company.companyId) {
				this.retrievePlantsByCompanyId(this.selectedValues.company.companyId.toString())
			}
			this.setSelectedCompany(this.selectedValues.company)
			if (this.selectedValues.plant.plantId) {
				this.setSelectedPlant(this.selectedValues.plant.plantId, this.selectedValues.plant.plantName)
			}
			this.firstRender = false
		}

		history.replaceState({}, '')

		try {
			const storedAssignment = localStorage.getItem('assignedPlants')
			if (storedAssignment) {
				this.assignedPlants = JSON.parse(storedAssignment)
			} else {
				console.error(
					"No data found in local storage for key 'assignedPlants' ",
				)
			}
		} catch (error) {
			console.error('Error parsing JSON data from local storage:', error)
		}

		if (this.currentRole === Roles.admin) {
			this.assignedPlants.map((assignment: Plant) =>
				this.plants.push(assignment),
			)
		} else {
			this.companyService.retrieveCompanies().subscribe({
				next: (companies) => {
					this.companies = companies
				},
				error: (response) => {
					this.errorMessage =
						this.errorService.handleRetrievalErrors(response)
				},
			})
		}
	}

	ngOnDestroy(): void {
		this.persistRefreshState()
	}

	private persistRefreshState(): void {
		this.refreshState.save('settings:units', {
			selectedValues: this.selectedValues,
			currentPage: this.currentPage,
		})
	}
}
